import hyRequest from '@/service'

/**
 * 通用模块API生成器（无固定后缀，完全适配任意接口规则）
 * **/
export const createModuleApiService = (moduleName: string) => {
  return {
    // 配置GET请求（适配任何get接口）
    get: (apiPath: string, params?: any, config?: any) => {
      return hyRequest.get({
        url: `/${moduleName}/${apiPath}`,
        params,
        ...config
      })
    },
    // 配置POST请求（适配任何post接口）
    post: (apiPath: string, data?: any, config?: any) => {
      return hyRequest.post({
        url: `/${moduleName}/${apiPath}`,
        data,
        ...config
      })
    },
    delete: (apiPath: string, params?: any, config?: any) => {
      return hyRequest.delete({
        url: `/${moduleName}/${apiPath}`,
        params,
        ...config
      })
    },
    put: (apiPath: string, data?: any, config?: any) => {
      return hyRequest.put({
        url: `/${moduleName}/${apiPath}`,
        data,
        ...config
      })
    },
    patch: (apiPath: string, data?: any, config?: any) => {
      return hyRequest.patch({
        url: `/${moduleName}/${apiPath}`,
        data,
        ...config
      })
    }
    // getPageList: (
    //   pageName: string,
    //   queryInfo: any,
    //   listPreStr: string = ''
    // ) => {
    //   return hyRequest.get({
    //     url: listPreStr
    //       ? `/${moduleName}/${pageName}`
    //       : `/${moduleName}/${pageName}/list`,
    //     params: queryInfo
    //   })
    // },
    // getPageDetail: (pageName: string, queryInfo: any) => {
    //   return hyRequest.get({
    //     url: `/${moduleName}/${pageName}/detail`,
    //     params: queryInfo
    //   })
    // },

    // // 删除实体 DELETE /{moduleName}/{pageName}/delete
    // deleteById: (pageName: string, data: any) => {
    //   const isBatch = 'ids' in data && Array.isArray(data.ids)
    //   const params = isBatch ? `ids=${data.ids.join(',')}` : `id=${data.id}`
    //   const url = isBatch
    //     ? `/${moduleName}/${pageName}/deleteBatch?${params}`
    //     : `/${moduleName}/${pageName}/delete?${params}`
    //   return hyRequest.delete({
    //     url
    //   })
    // },

    // // 更新状态 PATCH /{moduleName}/{pageName}/update-status
    // updateStatus: (pageName: string, data: any, preStr: string = '') => {
    //   return hyRequest.patch({
    //     url: `/${moduleName}/${pageName}/${preStr ? preStr : ''}update-status`,
    //     data
    //   })
    // },

    // // 创建实体 POST /{moduleName}/{pageName}/create
    // create: (pageName: string, data: any) => {
    //   return hyRequest.post({
    //     url: `/${moduleName}/${pageName}/create`,
    //     data
    //   })
    // },

    // // 更新实体 PUT /{moduleName}/{pageName}/update
    // update: (pageName: string, id: number | string, data: any) => {
    //   console.log(pageName, id, data)
    //   return hyRequest.put({
    //     url: `/${moduleName}/${pageName}/update`,
    //     data: { ...data, id }
    //   })
    // },

    // // 实体详情 GET /{moduleName}/{pageName}/detail
    // getDetail: (pageName: string, params: any) => {
    //   return hyRequest.get({
    //     url: `/${moduleName}/${pageName}/detail`,
    //     params
    //   })
    // },

    // // 导出数据 GET /{moduleName}/{pageName}/export
    // exportData: (pageName: string, exportParams: any) => {
    //   return hyRequest.get({
    //     url: `/${moduleName}/${pageName}/export`,
    //     params: exportParams,
    //     responseType: 'blob'
    //   })
    // },
    // // 导入数据 POST /{moduleName}/{pageName}/import
    // importData: (pageName: string, fileData: any) => {
    //   return hyRequest.post({
    //     url: `/${moduleName}/${pageName}/import`,
    //     data: fileData
    //   })
    // },

    // // 下载模板 GET /{moduleName}/{pageName}/get-import-template
    // downloadTemplate: (pageName: string, extraParams?: any) => {
    //   console.log(extraParams, 'extraParams')

    //   // 处理参数对象，转换为查询字符串
    //   const params = new URLSearchParams()
    //   if (extraParams && typeof extraParams === 'object') {
    //     Object.entries(extraParams).forEach(([key, value]) => {
    //       params.append(key, value)
    //     })
    //   }

    //   // 构建包含查询参数的 URL
    //   const url = `/${moduleName}/${pageName}/get-import-template${
    //     params.toString() ? `?${params.toString()}` : ''
    //   }`

    //   return hyRequest.get({
    //     url,
    //     responseType: 'blob'
    //   })
    // },
    // // 通用下拉精简列表
    // getSimpleList: (pageName: string, queryInfo: any) => {
    //   return hyRequest.get({
    //     url: `/${moduleName}/${pageName}/simple-list`,
    //     params: queryInfo
    //   })
    // },
    // // 审核操作
    // review: (pageName: string, data: any) => {
    //   return hyRequest.put({
    //     url: `/${moduleName}/${pageName}/review`,
    //     data
    //   })
    // },
    // submit: (pageName: string, data: any) => {
    //   return hyRequest.post({
    //     url: `/${moduleName}/${pageName}/submit`,
    //     data
    //   })
    // },
    // // 后端不统一后缀名的接口，直接传入拼接的url同步数据
    // syncData: (apiUrl: string, data: any) => {
    //   return hyRequest.post({
    //     url: `/${moduleName}/${apiUrl}`,
    //     data
    //   })
    // }
  }
}
// const baseCosApi = createModuleApiService('admin-api/cos')
// export const cosApi = {
//   ...baseCosApi,
//   getByPlId: (pageName: string, params: any) => {
//     return hyRequest.get({
//       // URL 格式对齐通用逻辑：/模块名/页面名/getByPlId（参数拼在查询串）
//       url: `admin-api/cos/${pageName}/getByPlId`,
//       params
//     })
//   }
// }
// 为不同模块创建API服务实例
export const systemApi = createModuleApiService('app-api/system')
export const eduCenterApi = createModuleApiService('app-api/educ') // 教务中心
export const cosApi = createModuleApiService('app-api/cos') // 课程中心
export const regApi = createModuleApiService('app-api/reg') // 课程中心
export const lrnApi = createModuleApiService('app-api/lrn') // 学习中心
export const exmApi = createModuleApiService('app-api/exm') // 考试中心
export const finApi = createModuleApiService('app-api/fin') // 支付中心
// 审核阶段
export const infraApi = createModuleApiService('app-api/infra')
// 其他的按上述模板添加
